export const SUBMISSION_TYPE_LABELS: Record<string, string> = {
  erasure: "Erasure Request",
  request: "Update Request",
  complaint: "Complaint",
};

export const getSubmissionTypeLabel = (type: string): string => {
  const key = (type || "").toString().toLowerCase();
  return SUBMISSION_TYPE_LABELS[key] || type;
};
